import { render, staticRenderFns } from "./ModalPreferencesBase.vue?vue&type=template&id=a240601c"
import script from "./ModalPreferencesBase.vue?vue&type=script&lang=js"
export * from "./ModalPreferencesBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports